import { type ChangeEvent } from 'react'

import { Dropdown, TextField } from '@joor/design-system'
import type { Option } from '@joor/design-system'
import styled from 'styled-components'

import type { TaxIdFieldErrors } from './taxIdVerification.types'

const VERIFICATION_SUCCESS_MESSAGE = 'Tax ID verified.'

const FieldHelperCaption = styled.span`
  display: block;
  margin: 0;
  font-family: var(--font-family-alpha);
  font-weight: var(--font-weight-medium);
  font-size: var(--size-font-extrasmall);
  letter-spacing: var(--letter-spacing-tight);
  line-height: var(--line-height-12);
`

const FieldError = styled(FieldHelperCaption)`
  margin-top: 4px;
  color: var(--color-error-500);
`

const SuccessHint = styled(FieldHelperCaption)`
  margin-top: 4px;
  color: var(--color-success-600);
`

const FieldsInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  width: 100%;

  > div {
    width: 100%;
  }
`

type TaxIdVerificationFieldsProps = {
  countryOptions: Option[]
  countryOption: Option | null
  taxId: string
  errors: TaxIdFieldErrors
  taxIdVerified?: boolean
  onCountrySelect: (args: { selected: Option }) => void
  onTaxIdChange: (value: string) => void
  onTaxIdBlur?: () => void
}

export function TaxIdVerificationFields({
  countryOptions,
  countryOption,
  taxId,
  errors,
  taxIdVerified = false,
  onCountrySelect,
  onTaxIdChange,
  onTaxIdBlur,
}: TaxIdVerificationFieldsProps) {
  return (
    <div>
      <FieldsInner>
        <div>
          <Dropdown
            testId="tax-id-country"
            label="Country"
            placeholder="Select"
            value={countryOption}
            onSelect={onCountrySelect}
            options={countryOptions}
            menuPosition="fixed"
          />
          {errors.country && <FieldError>{errors.country}</FieldError>}
        </div>
        <div>
          <TextField
            label="Tax ID"
            placeholder="e.g. 12-3456789"
            value={taxId}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              onTaxIdChange(e.target.value)
            }
            onBlur={onTaxIdBlur}
            errorMessage={errors.taxId}
          />
          {taxIdVerified && (
            <SuccessHint>{VERIFICATION_SUCCESS_MESSAGE}</SuccessHint>
          )}
        </div>
      </FieldsInner>
    </div>
  )
}
